import React from 'react';

export class BodyBackground extends React.Component{
  render(): React.ReactNode {
    return (
      <div className="absolute h-full w-full overflow-hidden -z-40">

      </div>
    )
  }
}
